import { render, staticRenderFns } from "./circlelecture.vue?vue&type=template&id=15f47699&scoped=true"
import script from "./circlelecture.vue?vue&type=script&lang=js"
export * from "./circlelecture.vue?vue&type=script&lang=js"
import style0 from "./circlelecture.vue?vue&type=style&index=0&id=15f47699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f47699",
  null
  
)

export default component.exports